import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const PrudenceFunds: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDirection="column"
			>
				<Flex
					alignItems={{ xs: "flex-start", md: "flex-start" }}
					justifyContent="center"
					columnGap="24px"
					justifyItems="center"
					width="100%"
					display="flex"
					as="section"
					rowGap="30px"
					flexDir={{
						xs: "column",
						md: "row",
					}}
				>
					<Flex flexDir="column" rowGap="16px">
						<Heading
							color="white"
							fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
							fontWeight="800"
							lineHeight={{ xs: "35px", lg: "83px" }}
						>
							#TheContext
						</Heading>
					</Flex>
					<Box
						w="1.5px"
						h={{ xs: "100%" }}
						bgColor="white"
						display={{ xs: "none", md: "block" }}
					/>
					<Box
						w={{ xs: "70%", sm: "60%" }}
						h="1.5px"
						bgColor="white"
						display={{ xs: "block", md: "none" }}
					/>
					{/*  */}
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Prudence of funds – The need of the hour
					</Heading>
				</Flex>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
				mb="20px"
			>
				<Flex
					flexDir={{
						xs: "column",
						md: "row",
					}}
					gap="20px"
					alignItems={{
						xs: "center",
						md: "unset",
					}}
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-07-10at113211AM-k5KNTHG5q9u4.jpeg"
						alt="Vikaas M Sachdeva"
						width="250px"
						height="250px"
						objectFit="cover"
						borderRadius="50%"
					/>
					<Flex direction="column">
						<Heading
							as="h1"
							fontWeight="800"
							pt="20px"
							variant="reportCardTitle"
							fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Vikaas M Sachdeva
							<Link
								href="https://www.linkedin.com/in/vikaasmsachdeva/"
								target="_blank"
								display={{ xs: "inline-block", md: "none" }}
								pl="10px"
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Heading>
						<Text
							color="text.mediumBlack"
							maxW={{
								xs: "100%",
								md: "120px",
							}}
							w="100%"
							fontSize="16px"
							lineHeight="22px"
							fontStyle="italic"
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Managing Director, Sundaram Alternates
						</Text>

						<Link
							href="https://www.linkedin.com/in/vikaasmsachdeva/"
							target="_blank"
							display={{
								xs: "none",
								md: "block",
							}}
						>
							<IconButton
								aria-label="linkedin"
								icon={<FaLinkedin size="28px" color="#067acc" />}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Flex>
				</Flex>
			</Box>
			<Box>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						The world of Alternative Investment Funds (AIFs) represents a
						dynamic and rapidly evolving segment of the financial market,
						offering significant alpha generation potential for sophisticated
						investors seeking high returns. Last year, AIFs surpassed the INR 10
						trillion-mark in investment commitments for the first time, driven
						by increased interest from affluent investors seeking higher returns
						compared to traditional investment options. By March 2024, these
						commitments had reached INR 11.35 trillion, reflecting a 4.6%
						increase quarter-over-quarter and more than 36% year-over-year
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" pt="8px">
						While AIFs serve as pooled investment vehicles for high-net-worth
						individuals, requiring a minimum investment of INR 1 crore, there is
						also an element of elevated risk management which needs to be kept
						in mind. The regulators have usually encouraged the industry and
						have gone to the extent of providing regulatory sandboxes for
						innovative ideas. It is incumbent on the industry, however, to
						ensure that they are not perceived as being walking to close to the
						line.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Recognising the size of this opportunity and the magnitude of their
						economic vibrancy is essential. We stand on the brink of a
						transformative moment over the next couple of decades, one that
						demands our immediate attention and urgent action
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Recent regulatory developments underscore the importance of caution
						and due diligence in managing AIFs to mitigate risks and ensure
						compliance with financial regulations.
					</Text>
				</Box>
				<Box my="16px">
					<Heading
						as="h1"
						fontWeight="800"
						pt="20px"
						variant="reportCardTitle"
						fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
						textAlign={{
							xs: "center",
							md: "left",
						}}
					>
						Regulatory developments and what they imply:
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Undoubtedly, AIFs essay a crucial role in capital formation,
						providing risk capital to enterprises, including unlisted companies,
						and facilitating the growth of the economy. From that point of view,
						today AIFs have started occupying a similar status as to what NBFCs
						and banks did a few years earlier.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Not surprisingly, the regulators are keen to make sure that the
						industry grows without making the commensurate errors which have
						transpired in the ecosystem earlier.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						On December 19, 2023, the Reserve Bank of India (RBI) issued a
						directive to banks and Non-Banking Financial Companies (NBFCs),
						referred to as Regulated Entities (REs), to liquidate their
						investments in AIFs that had downstream investments in debtor
						companies of the REs, failing which the REs would have to make 100%
						provisions for their investments in these AIFs.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Subsequent clarifications by the RBI on March 27, 2024, refined
						these guidelines – key points included the exclusion of equity
						investments in debtor companies from downstream investments,
						provisioning requirements only for the portion of investments in
						debtor companies, and the exclusion of investments through
						intermediaries like fund of funds or mutual funds from the scope of
						the directive.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						The intention clearly was to give a heads up to the industry to be
						judicious rather than impetuous in their approach to manage money.
						It clearly was a red flag to any potential concerns on likely
						evergreening of loans, among other transgressions
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						These measures are designed to ensure uniformity in implementation
						and address stakeholders&#39; concerns.
					</Text>
				</Box>
				<Box my="16px">
					<Heading
						as="h1"
						fontWeight="800"
						pt="20px"
						variant="reportCardTitle"
						fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
						textAlign={{
							xs: "center",
							md: "left",
						}}
					>
						Challenges and risk areas for AIFs
					</Heading>
					<Text variant="blogAnswer" py="16px">
						If one were to read the tea leaves, it is reasonably clear as to
						where the regulator is nudging the industry to move towards. They
						are doing this with robust guardrails created through dialogue, data
						analysis and discretion in equal doses.
					</Text>
				</Box>
				<Box my="10px">
					<Text variant="blogAnswer" py="16px">
						<span
							style={{
								fontWeight: 700,
								marginRight: "4px",
							}}
						>
							Case 1:
						</span>
						There can be a situation where regulated lenders invest in junior
						units of an AIF, which then funds the lender&#39;s stressed
						borrowers. This arrangement can mask the stress in the lender&#39;s
						books, circumventing provisioning and regulatory requirements.
						RBI&#39;s directives aim to curb this practice by requiring REs to
						liquidate such investments or provision them fully.
					</Text>
				</Box>
				<Box my="10px">
					<Text variant="blogAnswer" py="16px">
						<span
							style={{
								fontWeight: 700,
								marginRight: "4px",
							}}
						>
							Case 2:
						</span>
						Despite being managed domestically, some AIFs can potentially have
						foreign investors that influence their investment decisions. This
						structure could potentially undermining regulatory intent. The RBI
						and SEBI have recommended treating AIFs with significant foreign
						investment as indirect foreign investment, pending regulatory
						amendments.
					</Text>
				</Box>
				<Box my="10px">
					<Text variant="blogAnswer" py="16px">
						<span
							style={{
								fontWeight: 700,
								marginRight: "4px",
							}}
						>
							Case 3:
						</span>
						AIFs, classified as QIBs, enjoy certain benefits in IPO allocations.
						regulatory measures might be needed to ensure that only broad-based
						AIFs benefit from the QIB status.
					</Text>
				</Box>
				<Box my="10px">
					<Text variant="blogAnswer" py="16px">
						<span
							style={{
								fontWeight: 700,
								marginRight: "4px",
							}}
						>
							Case 4:
						</span>
						Purchasing Security Receipts (SRs) from Asset Reconstruction
						Companies (ARCs), allowing otherwise ineligible entities to acquire
						stressed assets. This practice necessitates tighter regulatory
						oversight.
					</Text>
				</Box>
				<Box my="16px">
					<Heading
						as="h1"
						fontWeight="800"
						pt="20px"
						variant="reportCardTitle"
						fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
						textAlign={{
							xs: "center",
							md: "left",
						}}
					>
						Emphasising prudence in fund management
					</Heading>
					<Text variant="blogAnswer" py="16px">
						The key to managing AIFs prudently lies in comprehensive due
						diligence, robust risk management frameworks, and adherence to
						regulatory requirements. Accordingly, fund managers should implement
						stringent due diligence processes to assess the credibility and
						regulatory compliance of their investments, including verifying the
						background of investors and ensuring investments do not facilitate
						regulatory circumvention.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Additionally, establishing robust risk management frameworks that
						include regular monitoring and evaluation of portfolio performance
						is crucial - these frameworks should be designed to identify
						potential risks early and take corrective actions promptly. It is
						advisable that AIFs adhere to all relevant regulatory requirements,
						including those related to investment limits, disclosure norms, and
						provisioning. This includes staying updated with regulatory changes
						and implementing necessary adjustments in fund operations.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Further, maintaining transparency in fund operations and providing
						regular reports to investors and regulators can build trust and
						enhance the credibility of AIFs. This involves clear communication
						of investment strategies, risks and performance metrics. Finally,
						fund managers should avoid complacency by continuously reassessing
						their strategies and adapting to changing market conditions and
						regulatory landscapes as this proactive approach can help mitigate
						risks and enable fund managers to capitalise on new opportunities.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						While the landscape of AIFs is fraught with opportunities and
						challenges, a prudent approach can go a long way towards navigating
						these issues effectively. Emphasising caution and avoiding
						complacency are essential for ensuring the long-term sustainability
						and credibility of AIFs, ultimately contributing to the stability
						and growth of the financial market.
					</Text>
				</Box>
			</Box>
			<Box width="100%" height="2px" bgColor="primary.200" />
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="18px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with&nbsp;
				{/* The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp; */}
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default PrudenceFunds;
